import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { showNavbar: true } // Hide navbar on other pages
  },
  {
    path: '/attractions',
    name: 'attractions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AttractionsView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },
  {
    path: '/attractions/:itemData',
    name: 'AttractionDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/AttractionDetail.vue'),
    props: true,
    meta: { showNavbar: false } // Hide navbar on other pages
  },
  {
    path: '/events',
    name: 'events',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/EventsView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },
  {
    path: '/hotels',
    name: 'hotels',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HotelsView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },
  {
    path: '/food',
    name: 'food',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FoodView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },{
    path: '/services',
    name: 'services',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ServicesView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { showNavbar: false } // Hide navbar on other pages
  },
]

const router = createRouter({
  history: createWebHistory(),//process.env.BASE_URL),
  routes
})

export default router
